// react 
import React from "react";
// css
import "./App.css";
// browserrouter 
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";

// Components
import Header from './Component/Header';
import Footer from "./Component/Footer";
// pages
import Home from "./pages/Home";
import PermissionPage from "./PermissionPage.jsx";
// About pages
import AboutUs from "./pages/About/AboutUs";
import Blog from "./pages/About/Blog";
import BlogCategory from "./pages/About/BlogCategory";
import Contact from "./pages/About/Contact";
// Shop pages
import Shop from "./pages/Shop/Shop";
import ShopGridCol3 from "./pages/Shop/ShopGridCol3";
import ShopListCol from "./pages/Shop/ShopListCol";
import ShopCart from "./pages/Shop/ShopCart";
import ShopCheckOut from "./pages/Shop/ShopCheckOut";
import ShopWishList from "./pages/Shop/ShopWishList";
// Store pages
import StoreList from "./pages/store/StoreList";
import SingleShop from "./pages/store/SingleShop";
// Account pages
import MyAccountOrder from "./pages/Accounts/MyAccountOrder";
import MyAccountSetting from "./pages/Accounts/MyAcconutSetting";
import MyAcconutNotification from "./pages/Accounts/MyAcconutNotification";
import MyAcconutPaymentMethod from "./pages/Accounts/MyAcconutPaymentMethod";
import MyAccountAddress from "./pages/Accounts/MyAccountAddress";
import MyAccountForgetPassword from "./pages/Accounts/MyAccountForgetPassword";
import MyAccountSignIn from "./pages/Accounts/MyAccountSignIn";
import MyAccountSignUp from "./pages/Accounts/MyAccountSignUp";

import MyOrders from "./pages/Accounts/MyOrders";
import OrderTrackingDialog from "./pages/Accounts/OrderTrackingDialog";
import InvoicePopup from "./pages/Reports/ViewInvoicePopup";
import ShopForm from "./pages/Shop/ShopForm";
import CustomerForm from "./pages/Accounts/CustomerForm";
import ShopLoginForm from './pages/Shop/ShopLoginForm';
import CustomerLogin from "./pages/Accounts/CustomerLogin";
import DeliveryBoyRegistrationForm from "./pages/Accounts/DeliveryBoyRegistrationForm";
import DeliveryBoyLogin from "./pages/Accounts/DeliveryBoyLogin";
import MasterInventory from "./pages/Shop/MasterInventory";
import CreateInventory from "./pages/Shop/CreateInventory";
import ProtectedRoute from "./pages/Shop/ProtectedRoute";
import CreateShopKeeperInv from "./pages/Shop/CreateShopKeeperInv";
import CustomerOrders from "./pages/Accounts/CustomerOrders";
import OrderReport from "./pages/Reports/OrderReports";
import SalesReport from "./pages/Reports/SalesReport";
import CustomerDashboard from "./pages/Accounts/Customer";
import MyCart from "./pages/Accounts/MyCart";
import OrderSuccess from "./pages/Accounts/OrderSuccess";
import DeliveryBoyDashboard from "./pages/Accounts/DeliveryBoyDashboard";
import SuperAdminDashboard from "./pages/Accounts/SuperAdminDashboard";
import { Dashboard } from "@mui/icons-material";
import EmployeeRegistrationForm from "./pages/Accounts/EmployeeRegistrationForm";
import MyShopInventory from "./pages/Shop/MyShopInventory";
import UpdateProfile from "./pages/Accounts/UpdateProfile";
import EditOrderPage from "./pages/Accounts/EditOrderPage";
import ChatWithCustomer from "./Component/Chatbot/ChatWithCustomer";
import UpdateCustomerProfile from "./pages/Accounts/UpdateCustomerProfile";
import AreaInServicePage from "./Component/AreaInServicePage";
import ShopInService from "./Component/ShopInService";
import DiscountShop from "./Component/DiscountShop";
import CustomerSupport from "./Component/CustomerSupport";
import ShopListByArea from "./Component/ShopListByArea";
import RelationManagerRegistrationForm from "./pages/Accounts/RelationManagerRegistrationForm";

import './i18n';
import MyShopsPage from "./pages/Accounts/MyShopsPage.js";
import PendingPaymentsPage from "./pages/Shop/PendingPaymentsPage.js";
import QRGenerator from "./pages/Accounts/QRGenerator.js";
import ShopsList from "./pages/Shop/ShopsList.js";
import ScanRedirect from "./pages/Accounts/ScanRedirect.js";
import PaymentDetails from "./pages/Accounts/PaymentDetails .js";
import ResetPassword from "./pages/Accounts/ResetPassword.jsx";
import SakhisSpecial from "./Component/SakhisSpecial/SakhisSpecial.jsx";
import PoliciesLegal from "./pages/Accounts/PoliciesLegal.jsx";

// Label Studio (Product Label Designer & Printing Module)
import LabelStudioLayout from "./pages/LabelStudio/LabelStudioLayout.jsx";
import LabelStudioDashboard from "./pages/LabelStudio/Dashboard.jsx";
import LabelStudioProductsList from "./pages/LabelStudio/ProductsList.jsx";
import LabelStudioProductForm from "./pages/LabelStudio/ProductForm.jsx";
import LabelStudioCategoriesPage from "./pages/LabelStudio/CategoriesPage.jsx";
import LabelStudioTemplatesList from "./pages/LabelStudio/TemplatesList.jsx";
import LabelStudioTemplateDesigner from "./pages/LabelStudio/TemplateDesigner.jsx";
import LabelStudioGenerateLabel from "./pages/LabelStudio/GenerateLabel.jsx";
import LabelStudioWeightSticker from "./pages/LabelStudio/WeightSticker.jsx";
import LabelStudioPrintHistoryPage from "./pages/LabelStudio/PrintHistoryPage.jsx";
import LabelStudioSettingsPage from "./pages/LabelStudio/SettingsPage.jsx";

function AppContent() {
  const location = useLocation();
    const hideFooterOn = [
    '/superadmin-dashboard',
    '/adminAccessPanel'
  ];       
  const showFooter = !hideFooterOn.some(p => location.pathname.startsWith(p));

  return (
    <>
    <ThemeProvider theme={theme}>
      <Routes>
        {/* 🔽 All your existing routes (just copy-paste them here once) */}
        <Route path="/" element={<Home />} />
        <Route path="/Shop" element={<Shop />} />
        <Route path="/ShopKeeperRegistration" element={<ShopForm />} />
        <Route path="/ShopKeeperLogin" element={<ShopLoginForm />} />
        <Route path="/ShopGridCol3" element={<ShopGridCol3 />} />
        <Route path="/ShopListCol" element={<ShopListCol />} />
        <Route path="/ShopWishList" element={<ShopWishList />} />
        <Route path="/ShopCheckOut" element={<ShopCheckOut />} />
        <Route path="/ShopCart" element={<ShopCart />} />
        <Route path="/create-ShopkeeperInv" element={<CreateShopKeeperInv />} />
        <Route path="/myshop-inventory" element={<MyShopInventory />} />
        <Route path="/shops-in-area/:areaName" element={<ShopListByArea />} />
        <Route path="/pending-payments" element={<PendingPaymentsPage />} />
        <Route path="/paymentdetails" element={<PaymentDetails />} />

        {/* Product Label Designer & Printing Module */}
        <Route path="/label-studio" element={<LabelStudioLayout />}>
          <Route index element={<LabelStudioDashboard />} />
          <Route path="products" element={<LabelStudioProductsList />} />
          <Route path="products/new" element={<LabelStudioProductForm />} />
          <Route path="products/:id/edit" element={<LabelStudioProductForm />} />
          <Route path="categories" element={<LabelStudioCategoriesPage />} />
          <Route path="templates" element={<LabelStudioTemplatesList />} />
          <Route path="templates/new" element={<LabelStudioTemplateDesigner />} />
          <Route path="templates/:id/edit" element={<LabelStudioTemplateDesigner />} />
          <Route path="generate" element={<LabelStudioGenerateLabel />} />
          <Route path="weight-sticker" element={<LabelStudioWeightSticker />} />
          <Route path="print-history" element={<LabelStudioPrintHistoryPage />} />
          <Route path="settings" element={<LabelStudioSettingsPage />} />
        </Route>


        {/*Customers Pages */}
       {/* ✅ QR Scan redirect route */}
        <Route path="/scan" element={<ScanRedirect />} />
        <Route path="/CustomerLogin" element={<CustomerLogin />} />
        <Route path="/customersorders" element={<CustomerOrders />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />
        <Route path="/updateProfile" element={<UpdateProfile />} /> 
        <Route path="/updateCustomerProfile" element={<UpdateCustomerProfile />} /> 
        <Route path="/areas" element={<AreaInServicePage />} /> 
        <Route path="/shop-in-service" element={<ShopInService />} />
        <Route path="/discount-shop" element={<DiscountShop />} />
        <Route path="/customer-support" element={<CustomerSupport />} />
         <Route path="/CustomerProfileRegistration" element={<CustomerForm />} />
           <Route path="/shops" element={<ShopsList />} />
        {/*SuperAdmin Dashboard */}
        <Route path="/superadmin-dashboard" element={<SuperAdminDashboard />} />
       
        <Route path="/adminAccessPanel" element={<PermissionPage />} />
        {/*Orders Reports Pages */}
        <Route
          path="/orderreports/:shopId"
          element={
            <OrderReport
              userRole="shopkeeper"
              userShopId={localStorage.getItem("shopkeeperID")}
            />
          }
        />           
        <Route
          path="/salesReports/:shopId"
          element={
            <SalesReport
              userRole="shopkeeper"
              userShopId={localStorage.getItem("shopkeeperID")}
            />
          }
        />    

        {/* <Route path="/salesReports" element={<SalesReport />} /> */}

        {/*Delivery Boy Pages */}
        <Route path="/DeliveryBoyRegistration" element={<DeliveryBoyRegistrationForm />} />
        <Route path="/deliveryBoyLogin" element={<DeliveryBoyLogin />} />
        <Route path="/deliveryBoyDashboard" element={<DeliveryBoyDashboard />} /> 

        {/* Store pages */}
        <Route path="/StoreList" element={<StoreList />} />
        <Route path="/SingleShop" element={<SingleShop />} />

        {/* Accounts pages */}
        <Route path="/myorders" element={<MyOrders />} />
        <Route path="/order-tracking" element={<OrderTrackingDialog />} />
        <Route path="/invoice" element={<InvoicePopup />} />
        <Route path="/mycart" element={<MyCart/>} />
        <Route path="/order-success/:orderId" element={<OrderSuccess />} />
        <Route path="/MyAccountSetting" element={<MyAccountSetting />} />
        <Route path="/MyAcconutNotification" element={<MyAcconutNotification />} />
        <Route path="/MyAcconutPaymentMethod" element={<MyAcconutPaymentMethod />} />
        <Route path="/MyAccountAddress" element={<MyAccountAddress />} />
        <Route path="/MyAccountForgetPassword" element={<MyAccountForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/MyAccountsSignIn" element={<MyAccountSignIn />} />
        <Route path="/MyAccountSignUp" element={<MyAccountSignUp />} />
        <Route path="/policies-legal" element={<PoliciesLegal />} />
        <Route path="/edit-order/:orderId" element={<EditOrderPage />} />
        <Route path="/EmployeeRegistration" element={<EmployeeRegistrationForm />} />
        <Route path="/RM-Registration" element={<RelationManagerRegistrationForm />} />
        <Route path="/my-shops" element={<MyShopsPage />} />
        {/* About pages */}
        <Route path="/Blog" element={<Blog />} />
        <Route path="/BlogCategory" element={<BlogCategory />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/adminAccessPanel" element={<PermissionPage />} />
         <Route path="/sakhis-special" element={<SakhisSpecial />} />

      </Routes>
</ThemeProvider>
      {/* ✅ Footer only shows if allowed */}
      {showFooter && <Footer />}
    </>
  );
}

// ✅ Main App
const App = () => {
  return (
    <Router>
      <AppContent />
      
    </Router>
  );
};

export default App;
